module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1520-2abbf9c3404ca64869540315b868033b.png";